module.exports = __webpack_public_path__ + "media/images/icons/filled/read-d642b73aae409bbe989c895f2f7cb805.svg";